import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Icon } from '@iconify/react'
import './Customer.scss'

import Payment from './Payment'
import AdjustDebt from './AdjustDebt'
import RoleChange from './RoleChange'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import Pagination from '../../../../components/pagination/Pagination'
import PageLoader from '../../../../components/loader/PageLoader'
import FormLoader from '../../../../components/loader/FormLoader'
import FullLoader from '../../../../components/loader/FullLoader'
import DebitWallet from './DebitWallet'
import EditCustomer from './EditCustomer'
import DebtSummarySection from '../debts/DebtSummarySection'
import ToggleSpecialFeatures from './ToggleSpecialFeatures'
import ToggleEarlyWaybillAccess from './ToggleEarlyWaybillAccess'
import CreatePaystackAccount from './CreatePaystackAccount'
import ToggleActivation from './ToggleActivation'
import AgentKycForm from '../kyc/AgentKycForm'
import { KycStatusPill } from '../kyc/KycReview'

function Customer() {
  const baseURL = (import.meta as any).env.VITE_BASE_URL
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [userData, setUserData] = useState<any>({})
  const [showSwitch, setShowSwitch] = useState(false)
  const [showDeduct, setShowDeduct] = useState(false)
  const [showRole, setShowRole] = useState(false)
  const [debitWallet, setDebitWallet] = useState(false)
  const { notify, profile } = useGlobalContext()
  const [showEditCustomer, setShowEditCustomer] = useState<any>(null)

  const navigate = useNavigate()
  const fetchUser = async () => {
    setLoading(true)
    get(`user/view/${id}`)
      .then((result: any) => {
        if (result.status === 200) {
          setUserData(result.data)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchUser()
  }, [])

  ///Bookings
  const [bookings, setBookings] = useState<any>({})
  const [transactions, setTransactions] = useState<any>({})
  const [bookingsLoading, setBookingsLoading] = useState(true)
  const [transactionsLoading, setTransactionsLoading] = useState(true)
  const [debtsTrail, setDebtsTrail] = useState<any>({})
  const [debtTrailLoading, setDebtTrailLoading] = useState(true)
  const [walletTrail, setWalletTrail] = useState<any>({})
  const [walletTrailLoading, setWalletTrailLoading] = useState(true)

  const [paginationPage, setPaginationPage] = useState('default')
  const [downloading, setDownloading] = useState(false)
  const [showToggleSpecialFeatures, setShowToggleSpecialFeatures] = useState(false)
  const [showToggleEarlyWaybillAccess, setShowToggleEarlyWaybillAccess] =
    useState(false)
  const [showToggleActivation, setShowToggleActivation] = useState(false)
  const [showCreatePaystackAccount, setShowCreatePaystackAccount] =
    useState(false)
  const [showKycForm, setShowKycForm] = useState(false)

  // Jump straight to this customer's latest KYC submission in the review screen
  const viewKycSubmission = () => {
    get(`kyc/admin/queue?userId=${id}&status=all&limit=1`)
      .then((result: any) => {
        const latest = result?.data?.docs?.[0]
        if (latest) navigate(`/admin/kyc-request/${latest._id}`)
        else notify('error', 'No KYC submission found for this customer')
      })
      .catch(() => notify('error', 'Could not load KYC submission'))
  }

  const fetchBookings = async (
    page: number,
    usage: string,
    pageSize: number,
  ) => {
    setBookingsLoading(true)
    let url = ''
    if (usage === 'all') {
      url = `admin/bookings?userId=${id}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/bookings?userId=${id}&page=${page}&limit=${pageSize}&from=${dates.from}&to=${dates.to}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setBookings(result)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }
  const fetchTransaction = async (
    page: number,
    usage: string,
    pageSize: number,
  ) => {
    setTransactionsLoading(true)
    let url = ''
    if (usage === 'all') {
      url = `admin/transactions?user_Id=${id}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/transactions?user_Id=${id}&page=${page}&limit=${pageSize}&from=${dates.from}&to=${dates.to}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setTransactions(result)
        } else {
          notify('error', result.message)
        }
        setTransactionsLoading(false)
      })
      .catch(() => {
        setTransactionsLoading(false)
      })
  }
  const fetchDebtTrail = async (
    page: number,
    usage: string,
    pageSize: number,
  ) => {
    setDebtTrailLoading(true)
    let url = ''
    if (usage === 'all') {
      url = `admin/debt-trails?userId=${id}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/debt-trails?userId=${id}&page=${page}&limit=${pageSize}&from=${dates.from}&to=${dates.to}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setDebtsTrail(result.data)
        } else {
          notify('error', result.message)
        }
        setDebtTrailLoading(false)
      })
      .catch(() => {
        setDebtTrailLoading(false)
      })
  }
  const fetchWalletTrail = async (
    page: number,
    usage: string,
    pageSize: number,
  ) => {
    setWalletTrailLoading(true)
    let url = ''
    if (usage === 'all') {
      url = `admin/wallet-trails?userId=${id}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/wallet-trails?userId=${id}&page=${page}&limit=${pageSize}&from=${dates.from}&to=${dates.to}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setWalletTrail(result.data)
        } else {
          notify('error', result.message)
        }
        setWalletTrailLoading(false)
      })
      .catch(() => {
        setWalletTrailLoading(false)
      })
  }
  useEffect(() => {
    fetchBookings(1, 'all', 10)
    fetchTransaction(1, 'all', 10)
    fetchDebtTrail(1, 'all', 10)
    fetchWalletTrail(1, 'all', 10)
  }, [])

  /// Switch Tables
  const [tab, setTab] = useState('booking')

  //Filter
  const [dates, setDates] = useState({
    from: '',
    to: '',
  })
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setDates((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }
  function handleFilter() {
    if (!dates.from || !dates.to) {
      notify('error', `Dates can't be empty`)
    } else {
      setPaginationPage('date')
      fetchBookings(1, 'filtered', 10)
      fetchTransaction(1, 'filtered', 10)
      fetchDebtTrail(1, 'filtered', 10)
      fetchWalletTrail(1, 'filtered', 10)
    }
  }

  const handleDownload = async (format: string) => {
    const token = sessionStorage.getItem('token')
    const apiUrl = `${baseURL}/admin/bookings/export?userId=${id}&from=${dates.from}&to=${dates.to}&format=${format}`
    try {
      // Make an API request to fetch the Excel file
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          // Add any necessary headers, like authorization if required
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      // Convert the response to a Blob
      const blob = await response.blob()

      // Extract the filename from the "Content-Disposition" header
      const fileName = `Bookings-${dates.from} to ${dates.to}`

      // Create a download link for the Blob
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName // Use the filename from the backend
      document.body.appendChild(a) // Append to the DOM
      a.click() // Trigger the download
      a.remove() // Clean up
      window.URL.revokeObjectURL(url) // Release memory
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }
  const handleTransactionsDownload = async (format: string) => {
    const token = sessionStorage.getItem('token')
    const apiUrl = `${baseURL}/admin/transactions/export?userId=${id}&from=${dates.from}&to=${dates.to}&format=${format}`
    try {
      // Make an API request to fetch the Excel file
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          // Add any necessary headers, like authorization if required
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      // Convert the response to a Blob
      const blob = await response.blob()

      // Extract the filename from the "Content-Disposition" header
      const fileName = `Transactions-${userData.firstname}-${dates.from} to ${dates.to}`

      // Create a download link for the Blob
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName // Use the filename from the backend
      document.body.appendChild(a) // Append to the DOM
      a.click() // Trigger the download
      a.remove() // Clean up
      window.URL.revokeObjectURL(url) // Release memory
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }

  return loading ? (
    <div className='home'>
      <PageLoader position='center' />
    </div>
  ) : (
    <div className='customer'>
      {downloading && <FullLoader />}
      {showToggleSpecialFeatures && (
        <ToggleSpecialFeatures
          userId={id}
          currentValue={userData.viewSpecialFeatures}
          onSuccess={(newValue: boolean) =>
            setUserData((prev: any) => ({ ...prev, viewSpecialFeatures: newValue }))
          }
          onClose={() => setShowToggleSpecialFeatures(false)}
        />
      )}
      {showToggleEarlyWaybillAccess && (
        <ToggleEarlyWaybillAccess
          userId={id}
          currentValue={userData.earlyWaybillAccess}
          onSuccess={(newValue: boolean) =>
            setUserData((prev: any) => ({
              ...prev,
              earlyWaybillAccess: newValue,
            }))
          }
          onClose={() => setShowToggleEarlyWaybillAccess(false)}
        />
      )}
      {showCreatePaystackAccount && (
        <CreatePaystackAccount
          userId={id}
          onSuccess={(account: any) =>
            setUserData((prev: any) => ({
              ...prev,
              account_number: account.account_number,
              bank: account.bank,
              customer_code: account.customer_code,
            }))
          }
          onClose={() => setShowCreatePaystackAccount(false)}
        />
      )}
      {showToggleActivation && (
        <ToggleActivation
          userId={id}
          isDeactivated={userData.deactivated}
          onSuccess={(newValue: boolean) =>
            setUserData((prev: any) => ({ ...prev, deactivated: newValue }))
          }
          onClose={() => setShowToggleActivation(false)}
        />
      )}
      {showKycForm && (
        <AgentKycForm
          userId={id!}
          customerName={`${userData.firstname || ''} ${userData.lastname || ''}`}
          onClose={() => setShowKycForm(false)}
          onSuccess={fetchUser}
        />
      )}
      {showRole && (
        <RoleChange
          userData={userData}
          fetchUser={fetchUser}
          setShowRole={setShowRole}
        />
      )}
      {showSwitch && (
        <Payment
          userData={userData}
          fetchUser={fetchUser}
          setShowSwitch={setShowSwitch}
        />
      )}
      {showDeduct && (
        <AdjustDebt
          fetchTransaction={fetchTransaction}
          fetchUser={fetchUser}
          setShowDeduct={setShowDeduct}
        />
      )}
      {debitWallet && (
        <DebitWallet
          fetchTransaction={fetchTransaction}
          fetchUser={fetchUser}
          setShowDeduct={setDebitWallet}
        />
      )}
      {showEditCustomer && (
        <EditCustomer
          fetchUser={fetchUser}
          setShowEditCustomer={setShowEditCustomer}
          userData={showEditCustomer}
        />
      )}
      <div className='top flex justify-between items-center'>
        <div className='back-btn' onClick={() => navigate(-1)}>
          <Icon icon='ion:return-up-back-outline' />
          <h2>Back</h2>
        </div>
        {profile.role === 'super admin' && (
          <button className='edit-btn' onClick={() => setShowEditCustomer(userData)}>
            Edit User
          </button>
        )}
      </div>
      {userData ? (
        <div className='customer-wrap'>
          <div className='profile-header'>
            <div className='avatar'>
              {userData.firstname?.[0]?.toUpperCase()}
              {userData.lastname?.[0]?.toUpperCase()}
            </div>
            <div className='profile-info'>
              <h1>
                {userData.firstname} {userData.lastname}
              </h1>
              <div className='meta'>
                <span>{userData.email}</span>
                {userData.phonenumber && <span>{userData.phonenumber}</span>}
                {userData.username && <span>@{userData.username}</span>}
              </div>
            </div>
            <span className='role-badge'>{userData.role}</span>
            {userData.deactivated && (
              <span className='role-badge deactivated-badge'>Deactivated</span>
            )}
          </div>
          <div className='one'>
            <div className='placed-cards'>
              <div className='placed-card'>
                <p>Wallet Balance</p>
                <h2>NGN{userData.balance.toLocaleString()}</h2>
                {(profile.role === 'super admin' ||
                  profile.role === 'manager' ||
                  profile.role === 'customer service') && (
                  <button onClick={() => setDebitWallet(true)}>
                    Create Transaction
                  </button>
                )}
              </div>
              <div className='placed-card'>
                <p>Total Charge</p>
                <h2>NGN{userData.totalCharge.toLocaleString()}</h2>
              </div>
              <div className='placed-card'>
                <p>Total Bookings</p>
                <h2>{userData.totalBookings}</h2>
              </div>
              <div className='placed-card'>
                <p>Total Outstanding</p>
                <h2>NGN{userData.debt.toLocaleString()}</h2>
                {userData.debt > 1 &&
                  (profile.role === 'super admin' ||
                    profile.role === 'manager' ||
                    profile.role === 'customer service') && (
                    <button onClick={() => setShowDeduct(true)}>
                      Log payment
                    </button>
                  )}
              </div>
              <div className='placed-card'>
                <p>Weight Discrepancy Balance</p>
                <h2>
                  NGN{userData.weight_discrepancy_balance.toLocaleString()}
                </h2>
              </div>
              <div className='placed-card'>
                <p>Weight Discrepancy Overdue</p>
                <h2 className='color-red'>
                  NGN{userData.weight_discrepancy_overdue.toLocaleString()}
                </h2>
              </div>
            </div>
            <div className='details'>
              <div className='details-card'>
                <p>Full Name</p>
                <h3>
                  {userData.firstname} {userData.lastname}
                </h3>
              </div>
              <div className='details-card'>
                <p>Username</p>
                <h3>{userData.username}</h3>
              </div>
              <div className='details-card'>
                <p>Phone number</p>
                <h3>{userData.phonenumber}</h3>
              </div>
              <div className='details-card'>
                <p>Email address</p>
                <h3>{userData.email}</h3>
              </div>
              <div className='details-card'>
                <p>Referral</p>
                <h3>{userData.referral}</h3>
              </div>

              <div className='details-card'>
                <p>Address</p>
                <h3>{userData.address}</h3>
              </div>
              <div className='details-card'>
                <p>City</p>
                <h3>{userData.city}</h3>
              </div>
              <div className='details-card'>
                <p>State</p>
                <h3>{userData.state}</h3>
              </div>
              <div className='details-card'>
                <p>Closest Station</p>
                <h3>{userData.closestStation || 'Not set'}</h3>
              </div>
              <div className='details-card'>
                <p>Role</p>
                <h3 className='capitalize'>{userData.role}</h3>
                {profile.role === 'super admin' && (
                  <button onClick={() => setShowRole(true)}>Change</button>
                )}
              </div>

              <div className='details-card'>
                <p>Payment Status</p>
                <h3>{userData.turnoff_payment ? 'OFF' : 'ON'}</h3>
                {profile.role === 'super admin' && (
                  <button onClick={() => setShowSwitch(true)}>switch</button>
                )}
              </div>
              <div className='details-card'>
                <p>Credit Limit</p>
                <h3>NGN {parseFloat(userData.creditLimit).toLocaleString()}</h3>
              </div>
              <div className='details-card'>
                <p>Account Number</p>
                <h3>{userData.account_number}</h3>
                {!userData.account_number &&
                  (profile.role === 'super admin' ||
                    profile.role === 'customer service') && (
                    <button onClick={() => setShowCreatePaystackAccount(true)}>
                      Create Account
                    </button>
                  )}
              </div>
              <div className='details-card'>
                <p>Bank</p>
                <h3>{userData.bank}</h3>
              </div>
              <div className='details-card'>
                <p>Account Status</p>
                <h3 className={userData.deactivated ? 'inactive' : 'active'}>
                  {userData.deactivated ? 'Deactivated' : 'Active'}
                </h3>
                {profile.role === 'super admin' && (
                  <button onClick={() => setShowToggleActivation(true)}>
                    {userData.deactivated ? 'Reactivate' : 'Deactivate'}
                  </button>
                )}
              </div>
              <div className='details-card'>
                <p>KYC Verification</p>
                <h3>
                  <KycStatusPill status={userData.kycStatus} />
                </h3>
                {['not_submitted', 'rejected', 'expired', undefined].includes(
                  userData.kycStatus,
                ) && (
                  <button onClick={() => setShowKycForm(true)}>Fill KYC</button>
                )}
                {userData.kycStatus &&
                  userData.kycStatus !== 'not_submitted' &&
                  (profile.role === 'super admin' ||
                    profile.role === 'customer service') && (
                    <button onClick={viewKycSubmission}>
                      {userData.kycStatus === 'pending_review'
                        ? 'Review KYC'
                        : 'View KYC'}
                    </button>
                  )}
              </div>
              <div className='details-card'>
                <p>View Special Features</p>
                <h3 className={userData.viewSpecialFeatures ? 'active' : 'inactive'}>
                  {userData.viewSpecialFeatures ? 'Enabled' : 'Disabled'}
                </h3>
                {profile.role === 'super admin' && (
                  <button onClick={() => setShowToggleSpecialFeatures(true)}>
                    {userData.viewSpecialFeatures ? 'Disable' : 'Enable'}
                  </button>
                )}
              </div>
              <div className='details-card'>
                <p>Early Waybill Access</p>
                <h3
                  className={userData.earlyWaybillAccess ? 'active' : 'inactive'}
                >
                  {userData.earlyWaybillAccess ? 'Enabled' : 'Disabled'}
                </h3>
                {profile.role === 'super admin' && (
                  <button onClick={() => setShowToggleEarlyWaybillAccess(true)}>
                    {userData.earlyWaybillAccess ? 'Disable' : 'Enable'}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className='two'>
            <div className='two-wrapper'>
              <div className='wrap-top flex justify-between flex-wrap items-center'>
                <div className='flex buttons'>
                  <button
                    className={tab === 'booking' ? 'active' : ''}
                    onClick={() => setTab('booking')}
                  >
                    Booking List
                  </button>
                  <button
                    className={tab === 'transaction' ? 'active' : ''}
                    onClick={() => setTab('transaction')}
                  >
                    Transaction List
                  </button>
                  <button
                    className={tab === 'wallet' ? 'active' : ''}
                    onClick={() => setTab('wallet')}
                  >
                    Wallet Trail
                  </button>
                  <button
                    className={tab === 'debt' ? 'active' : ''}
                    onClick={() => setTab('debt')}
                  >
                    Debt Trail
                  </button>
                  {profile.role !== 'agent' && (
                    <button
                      className={tab === 'debt-summary' ? 'active' : ''}
                      onClick={() => setTab('debt-summary')}
                    >
                      Debt Summary
                    </button>
                  )}
                </div>
                <div className='flex date-filter'>
                  <div className='flex items-center'>
                    <input
                      type='date'
                      name='from'
                      value={dates.from}
                      onChange={handleChange}
                      max={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                  <div className='flex items-center'>
                    <p>to</p>
                    <input
                      type='date'
                      name='to'
                      value={dates.to}
                      onChange={handleChange}
                      min={dates.from}
                      max={new Date().toISOString().split('T')[0]}
                    />
                  </div>

                  <button
                    disabled={!dates.from || !dates.to}
                    onClick={handleFilter}
                  >
                    filter
                  </button>
                </div>
              </div>
              {tab === 'booking' && (
                <>
                  <div className='home_tables'>
                    <div className='left'>
                      {bookingsLoading ? (
                        <FormLoader position='center' />
                      ) : (
                        <div className='table'>
                          {bookings.data.length > 0 ? (
                            <>
                              {paginationPage === 'date' && (
                                <div className='buttons flex'>
                                  <button onClick={() => handleDownload('csv')}>
                                    Export CSV
                                  </button>
                                  <button
                                    onClick={() => handleDownload('excel')}
                                  >
                                    Export EXCEL
                                  </button>
                                </div>
                              )}
                              <table>
                                <thead>
                                  <tr>
                                    <th>S/N</th>
                                    <th>Date/Time</th>
                                    <th>Amount</th>
                                    <th>Tracking ID</th>
                                    <th>Delivery Type</th>
                                    <th>Status</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {bookings.data.map((item: any, i: number) => (
                                    <tr key={item.id}>
                                      <td>{i + 1}</td>
                                      <td className='count'>
                                        {new Date(
                                          item.dateTime,
                                        ).toLocaleString()}
                                      </td>
                                      <td className='count'>
                                        NGN {item.amount.toLocaleString()}
                                      </td>
                                      <td className='count'>
                                        {item.trackingId}
                                      </td>
                                      <td className='count'>
                                        {item.deliveryType}
                                      </td>
                                      <td>
                                        <span
                                          className={`chip ${item.status.code}`}
                                        >
                                          {item.status.description}
                                        </span>
                                      </td>
                                      <td>
                                        <span
                                          onClick={() =>
                                            navigate(
                                              `/admin/booking/${item.id}`,
                                            )
                                          }
                                          className='view'
                                        >
                                          view
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            <h1>No Bookings To Show</h1>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {!bookingsLoading && (
                    <Pagination
                      className='pagination-bar'
                      currentPage={bookings.pagination.page}
                      totalCount={bookings.pagination.totalPages}
                      pageSize={bookings.pagination.limit}
                      onPageChange={(page: number, pageSize: number) => {
                        paginationPage === 'default'
                          ? fetchBookings(page, 'all', pageSize)
                          : fetchBookings(page, 'filtered', pageSize)
                      }}
                    />
                  )}
                </>
              )}
              {tab === 'transaction' && (
                <>
                  <div className='home_tables'>
                    <div className='left'>
                      {transactionsLoading ? (
                        <FormLoader position='center' />
                      ) : (
                        <div className='table'>
                          {transactions.transactions.length > 0 ? (
                            <>
                              {paginationPage === 'date' && (
                                <div className='buttons flex'>
                                  <button
                                    onClick={() =>
                                      handleTransactionsDownload('csv')
                                    }
                                  >
                                    Export CSV
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleTransactionsDownload('excel')
                                    }
                                  >
                                    Export EXCEL
                                  </button>
                                </div>
                              )}
                              <table>
                                <thead>
                                  <tr>
                                    <th>S/N</th>
                                    <th>Date/Time</th>
                                    <th>Amount</th>
                                    <th>Reference</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {transactions.transactions.map(
                                    (item: any, i: number) => (
                                      <tr key={item._id}>
                                        <td>{i + 1}</td>
                                        <td className='count'>
                                          {new Date(
                                            item.created_at,
                                          ).toLocaleString()}
                                        </td>
                                        <td className='count'>
                                          NGN {item.amount.toLocaleString()}
                                        </td>
                                        <td className={item.type}>
                                          {item.type}
                                        </td>
                                        <td>{item.usage}</td>
                                        <td>{item.reference}</td>
                                        <td className={item.status}>
                                          {item.status}
                                        </td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            <h1>No Bookings To Show</h1>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {!transactionsLoading && (
                    <Pagination
                      className='pagination-bar'
                      currentPage={transactions.currentPage}
                      totalCount={transactions.totalPages}
                      pageSize={transactions.pageSize}
                      onPageChange={(page: number, pageSize: number) => {
                        fetchTransaction(page, 'all', pageSize)
                      }}
                    />
                  )}
                </>
              )}
              {tab === 'debt' && (
                <>
                  <div className='home_tables'>
                    <div className='left'>
                      {debtTrailLoading ? (
                        <FormLoader position='center' />
                      ) : (
                        <div className='table'>
                          {debtsTrail.trails.length > 0 ? (
                            <>
                              <table>
                                <thead>
                                  <tr>
                                    <th>S/N</th>
                                    <th>Date/Time</th>
                                    <th>Amount</th>
                                    <th>Amount Before</th>
                                    <th>Amount After</th>
                                    <th>Usage</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {debtsTrail.trails.map(
                                    (item: any, i: number) => (
                                      <tr key={item._id}>
                                        <td>{i + 1}</td>
                                        <td className='count'>
                                          {new Date(
                                            item.createdAt,
                                          ).toLocaleString()}
                                        </td>
                                        <td className='count'>
                                          NGN {item.amount.toLocaleString()}
                                        </td>
                                        <td>
                                          NGN{' '}
                                          {item.amountBefore.toLocaleString()}
                                        </td>
                                        <td>
                                          NGN{' '}
                                          {item.amountAfter.toLocaleString()}
                                        </td>
                                        <td>{item.usage}</td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            <h1>No Trail To Show</h1>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {!debtTrailLoading && (
                    <Pagination
                      className='pagination-bar'
                      currentPage={debtsTrail.pagination.page}
                      totalCount={debtsTrail.pagination.totalPages}
                      pageSize={debtsTrail.pagination.limit}
                      onPageChange={(page: number, pageSize: number) => {
                        fetchDebtTrail(page, 'all', pageSize)
                      }}
                    />
                  )}
                </>
              )}
              {tab === 'wallet' && (
                <>
                  <div className='home_tables'>
                    <div className='left'>
                      {walletTrailLoading ? (
                        <FormLoader position='center' />
                      ) : (
                        <div className='table'>
                          {walletTrail.trails.length > 0 ? (
                            <>
                              <table>
                                <thead>
                                  <tr>
                                    <th>S/N</th>
                                    <th>Date/Time</th>
                                    <th>Amount</th>
                                    <th>Amount Before</th>
                                    <th>Amount After</th>
                                    <th>Usage</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {walletTrail.trails.map(
                                    (item: any, i: number) => (
                                      <tr key={item._id}>
                                        <td>{i + 1}</td>
                                        <td className='count'>
                                          {new Date(
                                            item.createdAt,
                                          ).toLocaleString()}
                                        </td>
                                        <td className='count'>
                                          NGN {item.amount.toLocaleString()}
                                        </td>
                                        <td>
                                          NGN{' '}
                                          {item.amountBefore.toLocaleString()}
                                        </td>
                                        <td>
                                          NGN{' '}
                                          {item.amountAfter.toLocaleString()}
                                        </td>
                                        <td>{item.usage}</td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            <h1>No Trail To Show</h1>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {!walletTrailLoading && (
                    <Pagination
                      className='pagination-bar'
                      currentPage={walletTrail.pagination.page}
                      totalCount={walletTrail.pagination.totalPages}
                      pageSize={walletTrail.pagination.limit}
                      onPageChange={(page: number, pageSize: number) => {
                        fetchWalletTrail(page, 'all', pageSize)
                      }}
                    />
                  )}
                </>
              )}
              {tab === 'debt-summary' && (
                <div className='home_tables'>
                  <div className='left'>
                    <DebtSummarySection userId={id!} userModel='User' />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>No User data to show</div>
      )}
    </div>
  )
}

export default Customer
